import { LanguageToggle } from 'pi-kiosk-shared/ui';
import type { LanguageTogglePlacement } from 'pi-kiosk-shared/ui';

export interface CustomerLanguageToggleProps {
  readonly dataTestId?: string;
  readonly placement?: LanguageTogglePlacement;
}

/** CZ/EN/SK flag toggle — same locales in dev and production builds. */
export function CustomerLanguageToggle({
  dataTestId,
  placement = 'header',
}: CustomerLanguageToggleProps): JSX.Element {
  return (
    <LanguageToggle
      surface="customer"
      i18nNamespace="customer"
      placement={placement}
      dataTestId={dataTestId}
    />
  );
}
